import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import { Download } from "lucide-react";
import { pageColors } from "../mock";
import { useAuth } from "../context/AuthContext";

const files = [
  {
    href: "/favicon.png",
    title: "Logo — Original PNG",
    desc: "Raster master file at 923×950. Use where SVG is not supported.",
    filename: "tmm-logo.png",
  },
];

const Downloads = () => {
  const { current } = useAuth();

  React.useEffect(() => {
    document.title = "TMM|DOWNLOADS";
  }, []);

  if (!current) {
    return (
      <>
        <Header hoverColor={pageColors.shop} compact={false} />
        <div className="gated-page">
          <h1>Members only</h1>
          <p>Sign in as a member to access downloads.</p>
          <Link to="/members" className="btn-solid">Go to Members</Link>
        </div>
      </>
    );
  }

  return (
    <>
      <Header hoverColor={pageColors.shop} compact={false} />
      <div className="downloads-page">
        <div className="downloads-hero">
          <h1 className="downloads-title">DOWNLOADS</h1>
          <p className="downloads-sub">
            Brand assets, free for members.
          </p>
        </div>

        <div className="downloads-grid">
          {files.map((f) => (
            <a
              key={f.href}
              className="download-card"
              href={f.href}
              download={f.filename}
            >
              <div className="download-icon">
                <Download size={22} />
              </div>
              <div className="download-info">
                <div className="download-name">{f.title}</div>
                <div className="download-desc">{f.desc}</div>
              </div>
              <div className="download-cta">Download</div>
            </a>
          ))}
        </div>
      </div>
    </>
  );
};

export default Downloads;
